import React, { PropsWithChildren, useContext } from 'react';

import { media } from 'context';
import { Animate, Layout, Text } from 'ds';
import { Color } from 'shared';

import { ReactComponent as AiAssistantIcon } from 'ds/ai-assistant.svg';

interface Props {
  color?: Color;
}

const StepTitle: React.FC<PropsWithChildren<Props>> = ({ children, color = 'purple-gradient' }) => {
  const { xs, sm } = useContext(media);
  const isMobile = xs || sm;

  return isMobile ? (
    <Animate duration={300} height={56} position="relative" top={14}>
      <Text size="headline-md" color={color}>
        {children}
      </Text>
    </Animate>
  ) : (
    <Layout gap={24} height="100%" align="center" flex>
      <AiAssistantIcon style={{ flexShrink: 0 }} width={72} height={72} />
      <Animate duration={300} position="relative" height={96} top={24}>
        <Text size="headline-xl" color={color}>
          {children}
        </Text>
      </Animate>
    </Layout>
  );
};

export default StepTitle;
